var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LocalSystems',{attrs:{"title":"WPAS (formally Myrddin)","notebook":"WPAS","scanResults":_vm.scanResults,"expectedPrefixes":_vm.expectedPrefixes}},[_c('p',[_vm._v("WPAS sends one extract per Healthboard, the following are "),_c('strong',[_vm._v("missing")]),_vm._v(" on this day:")])])
}
var staticRenderFns = []

export { render, staticRenderFns }